export default __webpack_public_path__ + "static/media/guesty_lite_step2.5eca6954.png";